export default {
    data() {
      return {
        requiredCapabilities: {
            'allow': true,
            'feed': true,
            'tracker': true,
            'viewProduct': true,
            'signIn': true,
            'addToCart': false,
            'purchase': true,
            'dkim': true,
            'spf': false,
            'linkDomain': true,
            'showBox': false,
            'orders': false
        }
      };
    },
    computed: {
        
    },
    methods: {
        canActivate(newCapabilities) {
            return Object.keys(this.requiredCapabilities).every(c => !this.requiredCapabilities[c] || newCapabilities[c]);
        },
        formatCapability(c) {
            switch(c) {
                case 'allow': return this.$t('overview.capabilities.allow');
                case 'feed': return this.$t('overview.capabilities.feed');
                case 'tracker': return this.$t('overview.capabilities.tracker');
                case 'viewProduct': return this.$t('overview.capabilities.viewProduct');
                case 'purchase': return this.$t('overview.capabilities.purchase');
                case 'addToCart': return this.$t('overview.capabilities.addToCart');
                case 'signIn': return this.$t('overview.capabilities.signIn');
                case 'dkim': return this.$t('overview.capabilities.dkim');
                case 'spf': return this.$t('overview.capabilities.spf');
                case 'linkDomain': return this.$t('overview.capabilities.linkDomain');
                //case 'showBox': return this.$t('overview.capabilities.showBox');
                case 'orders': return this.$t('overview.capabilities.orders');
                default: return c;
            }
        },
        hasDNSSetupCompleted(capabilities) {
            return capabilities['dkim'] && capabilities['spf'] && capabilities['linkDomain'];
        }
    },
    created() {  
    }
  }
